import { render, staticRenderFns } from "./select-many-checkbox-group.vue?vue&type=template&id=0d64571c&"
import script from "./select-many-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./select-many-checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VInput } from 'vuetify/lib/components/VInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VInput,VTextField})
